import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMemberAuth } from '../hooks/useMemberAuth';

const MemberPublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useMemberAuth();

  if (loading) {
    return null;
  }

  if (isAuthenticated()) {
    return <Navigate to="/associado/dashboard" replace />;
  }

  return children;
};

export default MemberPublicRoute;
